//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useRoute, useRouter } from '@nuxtjs/composition-api';
import {
  computed,
  ref,
  watch,
  onMounted,
  onBeforeUnmount,
} from '@nuxtjs/composition-api';
import { SfIcon, SfImage, SfBadge, SfButton } from '@storefront-ui/vue';
import {
  useApiError,
  usePrePayList,
  useOrderClose,
  useCategoryTree,
  useOCart,
  cartGetters,
} from '@bee-hole/coms';
import { onSSR } from '@vue-storefront/core';
import Notification from '~/components/Notification';
import { useUiNotification, useUiState } from '~/composables';
import Alert from '~/components/util/alert.vue';
import CartSidebar from '~/components/CartSidebar.vue';
import { hexToRGBA } from '@/plugins/utils';
export default {
  head() {
    try {
      const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
      const meta = this?.configs?.meta || [];
      const link = this?.configs?.link || [];

      const mates = meta.map((mitem) => {
        if (mitem.name) {
          return { name: mitem.name, content: mitem.content };
        } else {
          return { charset: mitem.charset };
        }
      });
      let cssText = '';
      cssText = this?.configs?.css?.value;
      if (this?.configs?.TopBar?.color) {
        cssText += '--top-bar-background:' + this?.configs?.TopBar?.color + ';';
      }
      return {
        htmlAttrs: {
          ...i18nHead.htmlAttrs,
          // myAttribute: this?.configs?.title,
        },
        title: this?.configs?.title,
        meta: [...mates, ...i18nHead.meta],
        link: [...link, ...i18nHead.link],
        style: [
          {
            cssText: `html{${cssText}}`,
          },
        ],
      };
    } catch (e) {
      return {};
    }
  },
  setup(props, context) {
    const {
      root: { $nuxt },
      root,
    } = context;
    const { error } = useApiError();
    const { catTreeGet, catTrees } = useCategoryTree('header_cat');
    const { getPrePayList, prepaylist } = usePrePayList('ToBePaid');
    const { closeOrder } = useOrderClose();
    // canshu
    const notify = useUiNotification();
    const route = useRoute();
    const notificationId = ref();
    const router = useRouter();
    const { cart } = useOCart();
    const { isLoginModalOpen, toggleLoginModal, resize, toggleCartSidebar } =
      useUiState();
    const Icon = computed(() => {
      if (root?.$options?.$mallConfig?.mall_web_config) {
        return root?.$options?.$mallConfig?.mall_web_config?.link?.[0]?.href;
      } else {
        return null;
      }
    });
    const storeTitle = computed(
      () => root?.$options?.$mallConfig?.mall_web_config?.title || ''
    );
    const cartTotalItems = computed(() => {
      const count = cartGetters.getTotalItems(cart.value);
      return count ? count?.toString() : null;
    });
    const handleActionClick = async () => {
      await getPrePayList();
      notify.dismiss(notificationId.value);
      if (prepaylist.value && prepaylist.value?.list?.length) {
        await closeOrder(prepaylist.value?.list[0]?.prepay_id);
      }
      // router.push(context.root.localePath('/my-account/History?open=2'));
    };
    onBeforeUnmount(() => {
      if (process.client) {
        // 清除 resize 事件处理器
        window.onresize = null;
      }
    });
    onMounted(() => {
      if (window) {
        window.onresize = resize;
      }
    });
    watch(error, async () => {
      if (error.value.code === 61) {
        if (!isLoginModalOpen.value) {
          toggleLoginModal();
        }
      } else {
        if (error.value.code === 2201) {
          return false;
        }
        let action = {};
        if (error.value.code === 3208 || error.value.code === 3128) {
          action = {
            text: $nuxt.$t('tap_cancel_order'),
            onClick: handleActionClick,
          };
        }
        if (error.value?.message) {
          console.log('error.value.message', error.value.message);
          notificationId.value = notify.send({
            type: error.value.code === 0 ? 'success' : 'danger',
            message:
              (error.value.code !== 0
                ? $nuxt.$t('prompt_error') + ': ' + (error.value.code + ' ')
                : '  ') + String($nuxt.$t(error.value.message)),
            persistent: true,
            time: error.value.time || 0,
            action,
          });
        }
        if (error.value.image) {
          await notify.dismiss(notificationId.value);
          // 等待1秒
          await new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, 300);
          });
          notificationId.value = notify.send({
            type: error.value.code === 0 ? 'info' : 'danger',
            image: error.value.image,
            persistent: true,
            time: error.value.time || 0,
            class: 'notificationImage centerImage',
            action,
          });
        }
        action = {};
      }
    });
    onSSR(() => {
      if (!catTrees.value || catTrees.value?.length === 0) {
        catTreeGet({});
      }
    });
    const configs = computed(
      () => context?.root?.$options?.$mallConfig?.mall_web_config
    );
    const bgColor = computed(() => {
      if (root?.$options?.$storeConfig?.mall_home_type === 'website') {
        const config = root?.$options?.$mallConfig?.mall_home_artice;
        // js #fff 转成rgba
        if (
          config?.headerBgColor?.indexOf('rgb') !== -1 &&
          config?.headerBgColor?.indexOf('rgb') !== undefined
        ) {
          return {
            background: config?.headerBgColor || '#ffffff',
            position: 'relative',
          };
        } else {
          return {
            background: hexToRGBA(config?.headerBgColor || '#ffffff', 0.5),
            position: 'relative',
          };
        }
      } else {
        return {
          background: '#ffffff',
          position: 'relative',
        };
      }
    });
    return {
      route,
      Icon,
      storeTitle,
      toggleCartSidebar,
      cartTotalItems,
      bgColor,
      configs,
    };
  },
  components: {
    SfIcon,
    SfImage,
    Notification,
    Alert,
    SfBadge,
    CartSidebar,
    SfButton,
  },
};
